const wrappedFunctions = require('./viewerScript').wrappedFunctions;

module.exports = {
  initAppForPage: wrappedFunctions.initAppForPage,
  createControllers: wrappedFunctions.createControllers,
  exports: {},
};
